/**
 * Значення «з коробки». Це лише початкове наповнення нової організації —
 * після створення все редагується у вебі й ніде більше в коді не згадується.
 */
/**
 * Розпорядок за замовчуванням — той, за яким курс жив, поки його не можна було
 * міняти. Тепер він живе в налаштуваннях курсу (`leaveSchedule`), а це лише
 * початкові значення. Порожнє поле — цього пункту в розпорядку немає.
 */
export const DEFAULT_LEAVE_SCHEDULE = {
    weekday: {
        dayFrom: '15:15',
        dayTo: '18:30',
        from: '19:10',
        toRegular: '21:00',
        toMorning: '07:30',
        reportFrom: '',
        reportOvernight: false,
        handoverFrom: '',
        beforeDutyFrom: '',
        beforeDutyTo: '',
        goodFrom: '',
        goodTo: '',
        kyivGoodFrom: '',
        kyivGoodTo: '',
        kyivDayFrom: '15:15',
        kyivDayTo: '18:30',
        kyivFrom: '19:10',
    },
    saturday: {
        dayFrom: '',
        dayTo: '',
        from: '17:00',
        toRegular: '21:30',
        toMorning: '08:30',
        // За рапортом у суботу відпускають з 15:15, а не о 17:00,
        // і до ранку — незалежно від того, киянин людина чи ні
        reportFrom: '15:15',
        reportOvernight: true,
        // Хто здав наряд у суботу — з 18:30
        handoverFrom: '18:30',
        beforeDutyFrom: '',
        beforeDutyTo: '',
        goodFrom: '',
        goodTo: '',
        kyivGoodFrom: '',
        kyivGoodTo: '',
        kyivDayFrom: '',
        kyivDayTo: '',
        kyivFrom: '17:00',
    },
    sunday: {
        dayFrom: '',
        dayTo: '',
        from: '09:00',
        toRegular: '21:00',
        toMorning: '07:30',
        reportFrom: '',
        reportOvernight: false,
        // Наряд з суботи на неділю відпускають о 18:30
        handoverFrom: '18:30',
        // Хто заступає в неділю — гуляє зранку і повертається до 14:00
        beforeDutyFrom: '09:00',
        beforeDutyTo: '14:00',
        goodFrom: '',
        goodTo: '',
        kyivGoodFrom: '',
        kyivGoodTo: '',
        kyivDayFrom: '',
        kyivDayTo: '',
        kyivFrom: '09:00',
    },
};
export const emptyThemePalette = () => ({
    bg: '',
    panel: '',
    panel2: '',
    line: '',
    text: '',
    muted: '',
});
/** Як у tokens.css — показуємо в піпетці, поки курс не задав свої. */
export const DEFAULT_THEME_PALETTES = {
    light: {
        bg: '#f5f5f7',
        panel: '#ffffff',
        panel2: '#fafafc',
        line: '#d2d2d7',
        text: '#1d1d1f',
        muted: '#6e6e73',
    },
    dark: {
        bg: '#000000',
        panel: '#1d1d1f',
        panel2: '#2c2c2e',
        line: '#2c2c2e',
        text: '#f5f5f7',
        muted: '#86868b',
    },
};
/** Тепліші поверхні замість холодного сірого Apple-подібного. */
export const WARM_THEME_PALETTES = {
    light: {
        bg: '#f6f0e8',
        panel: '#fffaf4',
        panel2: '#f3e9df',
        line: '#e0d2c4',
        text: '#2a221c',
        muted: '#7a6c60',
    },
    dark: {
        bg: '#161310',
        panel: '#221e1a',
        panel2: '#2e2823',
        line: '#3d362f',
        text: '#f3ece4',
        muted: '#9a8d80',
    },
};
export const DEFAULT_MEALS = [
    { code: 'b', name: 'Сніданок', short: 'С', accusative: 'сніданок' },
    { code: 'l', name: 'Обід', short: 'О', accusative: 'обід' },
    { code: 'd', name: 'Вечеря', short: 'В', accusative: 'вечерю' },
];
export const DEFAULT_MARK_TYPES = [
    {
        code: 'k',
        letter: 'к',
        label: 'Компенсація харчування',
        color: '#d8f2de',
        textColor: '#1a7f37',
        colorDark: '#1e3a26',
        textColorDark: '#57d97a',
        counted: true,
        spread: 1,
        eatsInCanteen: false,
    },
    {
        code: 'n',
        letter: 'н',
        label: 'Наряд на гуртожиток',
        color: '#fde5e5',
        textColor: '#c22b2b',
        colorDark: '#3a2224',
        textColorDark: '#f27272',
        counted: false,
        spread: 3,
        eatsInCanteen: true,
    },
    {
        code: 'p',
        letter: 'п',
        label: 'Присутній на прийомі їжі (наприклад добровыльно залишився в гуртожитку)',
        color: '#fbf0cf',
        textColor: '#9a6b00',
        colorDark: '#332b16',
        textColorDark: '#e3b341',
        counted: false,
        spread: 1,
        eatsInCanteen: true,
    },
    {
        code: 'chp',
        letter: 'чп',
        label: 'Черговий підрозділ',
        color: '#fde8d0',
        textColor: '#b35c00',
        colorDark: '#3a2c18',
        textColorDark: '#f2a94a',
        counted: false,
        spread: 3,
        eatsInCanteen: true,
    },
    {
        code: 'nk',
        letter: 'нк',
        label: 'Наряд на 27к',
        color: '#dce8fa',
        textColor: '#1f5fa8',
        colorDark: '#182a3a',
        textColorDark: '#6fa8e0',
        counted: false,
        spread: 3,
        eatsInCanteen: true,
    },
    {
        code: 'v',
        letter: 'в',
        label: 'Відпустка',
        color: '#ece4fb',
        textColor: '#6b3fa0',
        colorDark: '#2a2038',
        textColorDark: '#b18ce0',
        counted: false,
        spread: 1,
        eatsInCanteen: false,
        away: true,
        awayReason: 'відпустка',
    },
    {
        code: 'cyber',
        letter: 'кн',
        label: 'Наряд на СSIRT',
        color: '#e2f3f6',
        textColor: '#0f6f80',
        colorDark: '#16303a',
        textColorDark: '#5fc6da',
        counted: false,
        spread: 1,
        eatsInCanteen: true,
        duty: true,
        dutyOnly: true,
        dutyCountsAs: { code: 'n', weight: 0.5 },
        startMeal: 1,
        keepsLeave: true,
    },
    {
        code: 't8',
        letter: 'бр',
        label: 'Бойовий розподіл',
        color: '#e7eaf0',
        textColor: '#333941',
        counted: false,
        spread: 21,
        eatsInCanteen: true,
    },
    {
        code: 't9',
        letter: 'сс',
        label: 'Старший сержант на вихідні',
        color: '#f3ebf8',
        textColor: '#54127f',
        colorDark: '#351c44',
        textColorDark: '#cc91f2',
        counted: false,
        spread: 4,
        dutySpread: 3,
        eatsInCanteen: true,
        duty: true,
        dutyOnly: true,
        startMeal: 2,
    },
    {
        code: 'lr',
        letter: 'лр',
        label: 'Ліжковий режим ',
        color: '#fae0ea',
        textColor: '#a22456',
        colorDark: '#3a1d29',
        textColorDark: '#e885ab',
        counted: false,
        spread: 1,
        dutySpread: 1,
        eatsInCanteen: false,
        inExpense: false,
        duty: true,
        dutyOnly: true,
        awayReason: 'хвороба',
    },
    {
        code: 'h',
        letter: 'ш',
        label: 'Шпиталь',
        color: '#fde6d6',
        textColor: '#a2461b',
        colorDark: '#3b2519',
        textColorDark: '#f0a173',
        counted: false,
        spread: 1,
        eatsInCanteen: false,
        awayReason: 'лікування в шпиталі',
    },
];
export const DEFAULT_RANKS = [
    { code: 'soldier', name: 'солдат', gen: 'солдата', dat: 'солдату', short: 'солдат' },
    { code: 'jr_sgt', name: 'молодший сержант', gen: 'молодшого сержанта', dat: 'молодшому сержанту', short: 'мол. с-т' },
    { code: 'sgt', name: 'сержант', gen: 'сержанта', dat: 'сержанту', short: 'с-т' },
    { code: 'sr_sgt', name: 'старший сержант', gen: 'старшого сержанта', dat: 'старшому сержанту', short: 'ст. с-т' },
    { code: 'chief_sgt', name: 'головний сержант', gen: 'головного сержанта', dat: 'головному сержанту', short: 'гол. с-т' },
    { code: 'staff_sgt', name: 'штаб-сержант', gen: 'штаб-сержанта', dat: 'штаб-сержанту', short: 'штаб-с-т' },
    { code: 'master_sgt', name: 'майстер-сержант', gen: 'майстер-сержанта', dat: 'майстер-сержанту', short: 'майстер-с-т' },
    { code: 'lt', name: 'лейтенант', gen: 'лейтенанта', dat: 'лейтенанту', short: 'лейтенант' },
    { code: 'sr_lt', name: 'старший лейтенант', gen: 'старшого лейтенанта', dat: 'старшому лейтенанту', short: 'ст. лейтенант' },
    { code: 'capt', name: 'капітан', gen: 'капітана', dat: 'капітану', short: 'капітан' },
    { code: 'major', name: 'майор', gen: 'майора', dat: 'майору', short: 'майор' },
    { code: 'lt_col', name: 'підполковник', gen: 'підполковника', dat: 'підполковнику', short: 'підполковник' },
    { code: 'col', name: 'полковник', gen: 'полковника', dat: 'полковнику', short: 'полковник' },
];
export const DEFAULT_POSITIONS = [
    { code: 'member', name: 'Курсант', nameDat: 'курсанту', short: '' },
    { code: 'sq1', name: 'Командир І відділення', nameDat: 'командиру І відділення', short: 'КВ-1' },
    { code: 'sq2', name: 'Командир ІІ відділення', nameDat: 'командиру ІІ відділення', short: 'КВ-2' },
    { code: 'platoon', name: 'Командир групи', nameDat: 'командиру групи', short: 'КГ' },
    { code: 'master', name: 'Старшина', nameDat: 'старшині', short: 'СТ' },
];
/** Кому посаду не вказали — курсант. */
export const DEFAULT_POSITION_CODE = DEFAULT_POSITIONS[0].code;
/** Групи посадовців, які підставляються в документи. */
export const OFFICIAL_KINDS = [
    { kind: 'chief', label: 'Начальник (кому рапорт)' },
    { kind: 'deputy', label: 'Заступник' },
    { kind: 'courseHead', label: 'Начальник курсу (клопоче)' },
    { kind: 'medic', label: 'Погоджує (медслужба)' },
];
export const DEFAULT_REPORT_LAYOUT = {
    body: 'Прошу Вашого дозволу на виплату грошової компенсації замість належного ' +
        'харчування за {MEALS}.',
    quickOfficials: {},
};
export const DEFAULT_DUTIES = {
    markKind: 'n',
    sectionMarks: [
        { section: 'КБ', markKind: null },
        { section: 'ЧП', markKind: 'chp' },
        { section: 'НК', markKind: 'nk' },
    ],
    mealsCovered: 3,
};
/**
 * Розкладка бланка відомості з першої версії: список із 14-го по 76-й рядок,
 * числа місяця в 12-му, дні починаються з колонки F.
 */
export const DEFAULT_TABLE_TEMPLATE = {
    firstRow: 14,
    lastRow: 76,
    dayHeaderRow: 12,
    firstDayCol: 6,
    columns: { num: 1, rank: 2, name: 3, unit: 4, code: 5 },
    totalColumn: 'CU',
    title: [
        { cell: 'A8', text: 'СПИСОК' },
        {
            cell: 'A9',
            text: 'особового складу {COURSE} для виплати грошової компенсації замість ' +
                'встановленої вартості Норми №1 - загальновійськова за {MONTH} місяць {YEAR} року',
        },
    ],
    signatureCells: [
        { position: 'BW3', name: 'BW4', date: 'BW6', dateMask: '____.___.' },
        { position: 'A78', rank: 'A79', name: 'W79', date: 'A80', dateMask: '___.____.' },
        { position: 'A83', rank: 'A84', name: 'W84', date: 'A85', dateMask: '___.____.' },
        { position: 'A88', rank: 'A89', name: 'W89', date: 'A90', dateMask: '___.____.' },
        { position: 'A93', rank: 'A94', name: 'W94', date: 'A95', dateMask: '___.____.' },
        { position: 'A98', name: 'W99', date: 'A100', dateMask: '___.____.' },
    ],
};
/**
 * Шаблони «з коробки»: хто мешкає вдома — компенсація щодня, хто в
 * розташуванні — лише на вихідних. Обидва редагуються у вебі, як і будь-які інші.
 */
export function defaultMealPatterns(meals, weekStart = 1) {
    return [
        {
            id: 'home',
            name: 'Мешкає вдома',
            hint: 'Харчується вдома — компенсація за всі прийоми їжі',
            days: defaultTemplate(true, meals, weekStart),
            isDefault: false,
        },
        {
            id: 'barracks',
            name: 'У розташуванні',
            hint: 'Їсть у їдальні, вдома — лише на вихідних',
            days: defaultTemplate(false, meals, weekStart),
            isDefault: true,
        },
    ];
}
/** Порожня сітка 7 × прийоми їжі. */
export const emptyWeek = (meals) => Array.from({ length: 7 }, () => Array.from({ length: meals }, () => false));
export function defaultOrgSettings() {
    return {
        locale: 'uk',
        accent: '',
        palettes: { light: emptyThemePalette(), dark: emptyThemePalette() },
        meals: DEFAULT_MEALS.map(m => ({ ...m })),
        mealPatterns: defaultMealPatterns(DEFAULT_MEALS.length),
        markTypes: DEFAULT_MARK_TYPES.map(m => ({ ...m })),
        weekStart: 1,
        documents: {
            institution: '',
            institutionDat: '',
            course: '',
            courseShort: '',
            city: 'Київ',
            clerkName: '',
            clerkPhone: '',
            defaultTemplates: {},
            kindOfficials: {},
            expenseTally: 'eating',
            dutyReport: { from: '15:15', to: '07:30', reason: '' },
            bonusReport: { amount: '', penalized: [] },
        },
        tableSignatures: [],
        leaveListSigners: { approve: { officialId: '', roleKind: '' }, authorId: '' },
        leaveUnits: [],
        leaveMarks: {},
        leaveSchedule: structuredClone(DEFAULT_LEAVE_SCHEDULE),
        tableTemplate: structuredClone(DEFAULT_TABLE_TEMPLATE),
        canteen: {
            title: ['СПИСОК', 'курсантів {COURSE} які забезпечуються ', 'харчуванням у їдальні на період за {DATE}'],
            signOfficial: '',
        },
        report: structuredClone(DEFAULT_REPORT_LAYOUT),
        duties: structuredClone(DEFAULT_DUTIES),
        features: {
            reports: true,
            canteenList: true,
            expenseNote: true,
            telegramBot: false,
            duties: true,
        },
        bot: {
            enabled: false,
            webUrl: '',
            staffTelegramIds: [],
            notifyChanges: true,
            leaveReport: false,
            dutyReport: false,
        },
    };
}
/**
 * Типовий тижневий розклад: `everyDay` — компенсація щодня (хто харчується
 * вдома), інакше лише вихідні. Використовується як заготовка для шаблонів.
 */
export function defaultTemplate(everyDay, meals, weekStart = 1) {
    return Array.from({ length: 7 }, (_, i) => {
        // i — індекс у тижні від weekStart; переводимо у день тижня (0 = неділя)
        const weekday = (i + weekStart) % 7;
        const isWeekend = weekday === 0 || weekday === 6;
        return Array.from({ length: meals }, () => (everyDay ? true : isWeekend));
    });
}
//# sourceMappingURL=defaults.js.map